<template>
  <div>
    <div class="box" :value="confirmEvent">
        <BBtnSelectUploadFile
          class="button"
          btn-txt="上传本地文件"
          v-model="data"
        />
      <div class="video-box">
      <div v-show="display" >
        <div class="inner-box">
          <img  style="width: 110px; height: 110px" src="../../assets/apk.png" />
          <img
            v-if="deleteFlag"
            class="delete-img"
            src="@/assets/circle-delete.png"
            v-on:click="deleteFile"
            alt=""
          />
          </div>
          <BProgress v-if="imgFlag" v-model="progress" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBtnSelectUploadFile from "../../components2/BBtnSelectUploadFile";
import BProgress from "../../components2/BProgress";
import { uploadPublic } from "@/api/upload";
import Vue from "vue";

export default {
  name: "PopupContents",
  props: {
    confirmEvent: Boolean,
  },
  components: {
    BBtnSelectUploadFile,
    BProgress,
  },
  data() {
    return {
      returnData: [],
      data: null,
      display: false,
      isMulti: true,
      fileList: [],
      fileData: {
        name: "",
        fileUrl: "",
      },
      progress: 0,
      imgFlag: true,
      deleteFlag: true,
      dragDropValue: {
        data: [],
        dummy: 1,
      },
    };
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    deleteFile() {
      this.display = false;
      this.fileList = []
    },
    async doUpload() {
        var formData = new FormData();
        formData.append("file", this.data.files[0]);
          console.log("999999 = ",this.doUploadProgress)
        const data = await uploadPublic(formData, this.doUploadProgress);
        if (this.progress > 100 || this.progress == 100) {
          //this.progress = this.progress;
          this.deleteFlag = false;
          this.imgFlag = false;
          this.progress = 0;
            Vue.prototype.$vsnackbar.show("上传成功");
        }
        var fileData = {};
        fileData.fileUrl = data[0];
        fileData.fileName = this.fileList[0].fileName;
      this.result(fileData);
      // 关闭弹层
      this.$emit("input", false);
    },
    doUploadProgress(event) {
      this.progress =
        (event.loaded / this.data.files[0].size) * 100;
    },
  },
  watch: {
    data() {
      this.display = true;
      var URL = window.URL || window.webkitURL;
       
        var fileUrl = URL.createObjectURL(this.data.files[0]);
        var fileName = this.data.files[0].name;
        var params = {
          name: fileName,
          length: this.data.files[0].name.length,
        }
        // 共通check
        var obj = this.comUtils.fileUploadCheck(params,'apk')
        if (obj.snackbarText !== "") {
          Vue.prototype.$valertbar.show(obj.snackbarText);
          this.deleteFile()
        } else {
            this.deleteFlag =true,
            this.imgFlag = false,
            this.progress = 0,
            this.fileData = {
              name: fileName,
              fileUrl: fileUrl,
            },
          this.fileList.push(this.fileData);
        }
    },
    confirmEvent() {
      if (this.confirmEvent === true) {
         var msg = this.comUtils.fileUploadCheck(this.fileList[0],'apk')
          if (msg !== undefined) {
            if (msg.snackbarText !== "") {
                  Vue.prototype.$valertbar.show(msg.snackbarText);
                  // 关闭弹层
                this.$emit("input", false);
                this.result(this.returnData);
              } else {
                this.doUpload();
                this.imgFlag = true;
              }
          } else {
            // 关闭弹层
            this.$emit("input", false);
            this.result(this.returnData);
          }
      }
    }
  },
};

</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.area-box {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.button {
  align-self: flex-start;
}

.video-box {
  display: flex;
  justify-content: center;
  width: 700px;
  height: auto;
  margin: 50px 0;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
}

.item {
  margin-left: 3px;
  margin-right: 3px;
}

.video {
  width: 448px;
  height: 273px;
  background: #000000;
}

.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: -12px;
  top: -5px;
}

.upload-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}
.fileName_list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
